module.exports = __webpack_public_path__ + "static/media/icon-button-settings.ffa1e45a.svg";